import { Injectable } from "@angular/core";
import { HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable, catchError, map, of, throwError } from "rxjs";
import { ApiService } from "../api.service";
import { ETagStore } from "./etag-store.service";

@Injectable({ providedIn: "root" })
export class HomeApiEtagClientService {
  constructor(
    private readonly api: ApiService,
    private readonly etagStore: ETagStore
  ) {}

  getWithEtag<T>(endpoint: string, params?: Record<string, any>, ifNoneMatch?: string): Observable<T> {
    const key = this.etagStore.buildKey(endpoint, params);
    const cached = this.etagStore.getEntry<T>(key);
    const cacheEtag = ifNoneMatch ?? cached?.etag;
    const headers = cacheEtag ? new HttpHeaders().set("If-None-Match", cacheEtag) : undefined;

    return this.api.getWithResponse<T>(endpoint, params, headers).pipe(
      map((response: HttpResponse<T>) => {
        const body = response.body as T;
        const etag = response.headers.get("ETag") ?? response.headers.get("etag");
        if (etag && body !== null && body !== undefined) {
          this.etagStore.setEntry(key, etag, body);
        }
        return body;
      }),
      catchError((error) => {
        if (error?.status === 304 && cached?.data) {
          return of(cached.data);
        }
        return throwError(() => error);
      })
    );
  }

  clearByPrefix(prefix: string): void {
    this.etagStore.clearByPrefix(prefix);
  }
}
